import type { NextPage } from 'next';
import OrdersListPage from './orders';

const Home: NextPage = () => {
  return <OrdersListPage />;
};

export default Home;
